import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControlLabel,
  FormGroup,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Switch,
  Tab,
  Tabs,
  TextField,
  Tooltip,
} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import serialize from "serialize-javascript";
import { ArrowForward, BorderAll, CheckBoxOutlineBlank, FilterList, ViewAgendaOutlined } from "@material-ui/icons";
import PrintIcon from "@material-ui/icons/Print";
import SaveIcon from "@material-ui/icons/Save";
import QueueIcon from "@material-ui/icons/Queue";
import MapIcon from "@material-ui/icons/Map";
import PropTypes from "prop-types";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { globalStyles } from "../../assets/globalStyles";
import { selectDate } from "../../features/konfiguration/konfigurationSlice";
import { toUTCDateString } from "../../utils/utils";
import { NetzwirtschaftGraphen } from "./graphen";
import { NetzwirtschaftInput } from "./input";
// import { NetzwirtschaftMap } from "./map";
import {
  setViewMode,
  getExcelData,
  getGraphData,
  loadGespeicherteSuche,
  saveSearch,
  selectMultiView,
  selectSelectedTab,
  selectSucheLoading,
  selectTabs,
  setMultiView,
  setShowEreignisse,
  selectUmspannwerkLoading,
  selectViewMode,
} from "./netzwirtschaftSlice";
import { useStyles } from "./netzwirtschaftStyles";
import { multiViewType, TabData } from "./netzwirtschaftTypes";
import { NetzwirtschaftMap } from "./map";
import { selectMessstellenLookup } from "../../features/messstellenLookup/messstellenLookupSlice";

function TabPanel(
  props: {
    children: JSX.Element[] | JSX.Element;
    value: number;
    index: number;
  } & React.HTMLAttributes<HTMLDivElement>
) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography component={"div"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export interface NetzwirtschaftTabProps {
  tabData: TabData;
  index: number;
  viewMode: string;
}
export const NetzwirtschaftTab = ({ tabData, index }: NetzwirtschaftTabProps): JSX.Element => {
  const dispatch = useAppDispatch();

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  const sucheLoading: boolean = useAppSelector(selectSucheLoading);
  const isUTC = useAppSelector(selectDate);

  const { tab, showGraphButton } = useStyles();

  const selectedTab: number = useAppSelector(selectSelectedTab),
    tabs: TabData[] = useAppSelector(selectTabs),
    multiView: multiViewType = useAppSelector(selectMultiView);

  const [selectedTabFilter, setSelectedTabFilter] = React.useState("allgemein");

  const [filter, setFilter] = React.useState(true);
  const [openSaveDialog, setOpenSaveDialog] = React.useState(false);
  const [savedSearchName, setSavedSearchName] = React.useState("");
  const [showMap, setShowMap] = React.useState(false);
  const save = () => {
    if (savedSearchName) {
      setOpenSaveDialog(false);
      const data: TabData = JSON.parse(
        serialize(
          tabs.find((x) => x.index == selectedTab),
          { isJSON: true }
        )
      );
      data.csvData = [];
      data.graphData = {
        yAxisTitleText: "",
        isNanoseconds: false,
        series: [],
        ereignisse: [],
        showEreignisse: false,
        geflaggteMesswerte: [],
        singlePoints: [],
      };
      dispatch(saveSearch(savedSearchName, serialize(data, { isJSON: true })));
      setSavedSearchName("");
    }
  };
  function duplicateTab(e: TabData) {
    const tabdataTemp = e;
    dispatch(loadGespeicherteSuche(tabdataTemp));
  }

  const messstellenLookup = useAppSelector(selectMessstellenLookup);
  const uwLoading = useAppSelector(selectUmspannwerkLoading);
  const viewMode = useAppSelector(selectViewMode);

  function getSchaltfeld(name: string) {
    const currentMessstelle = messstellenLookup.find((x) => x.name == name);
    if (currentMessstelle) return currentMessstelle.schaltfeld;
    return "";
  }

  const getMapDialogTitle = (uw: string, messpunkt: string): string => {
    if (messpunkt) {
      return `Messpunkt ${uw} ${getSchaltfeld(messpunkt)} (${messpunkt})`;
    } else {
      if (uw) {
        return `Messpunkte für Umspannwerk ${uw}`;
      } else {
        return `Messpunkte`;
      }
    }
  };
  return (
    <TabPanel key={index} value={selectedTab} index={tabData.index} className={tab}>
      <Paper className={classes.paper} style={{ marginBottom: "10px" }}>
        <Grid item md={12} style={{ alignItems: "end", textAlign: "right", paddingBottom: "10px" }}>
          <Button disabled={uwLoading} onClick={() => setShowMap(true)}>
            <Tooltip title="Karte">
              <MapIcon color={uwLoading ? "disabled" : "secondary"} />
            </Tooltip>
          </Button>
          <Button
            onClick={() => {
              const w = window.open();
              tabs.forEach((tab) => {
                const chartPromise = ApexCharts.exec(tab.index.toString(), "dataURI");
                if (chartPromise)
                  chartPromise.then((imgURI: { imgURI: string }) => {
                    const img = new Image();
                    //eslint-disable-next-line scanjs-rules/assign_to_src
                    img.src = imgURI.imgURI;
                    /* eslint-disable no-unsanitized/method */
                    w?.document.write("<style>@media print { img { width: 100%; } } </style>");
                    w?.document.write(img.outerHTML);
                    w?.document.write(
                      "<br/><br/><br/><table style='font-family: arial, sans-serif;border-collapse: collapse;width: 100%;'><tr><th style='border: 1px solid #dddddd;text-align: left;padding: 8px;'>Umspannwerk</th><th style='border: 1px solid #dddddd;text-align: left;padding: 8px;'>Messstelle</th><th style='border: 1px solid #dddddd;text-align: left;padding: 8px;'>Rekorder</th><th style='border: 1px solid #dddddd;text-align: left;padding: 8px;'>Messgrößen</th><th style='border: 1px solid #dddddd;text-align: left;padding: 8px;'>Startzeitpunkt</th><th style='border: 1px solid #dddddd;text-align: left;padding: 8px;'>Endzeitpunkt</th></tr><tr><td style='border: 1px solid #dddddd;text-align: left;padding: 8px;'>" +
                        tab.fields.uw +
                        "</td><td style='border: 1px solid #dddddd;text-align: left;padding: 8px;'>" +
                        tab.fields.messpunkt +
                        "</td><td style='border: 1px solid #dddddd;text-align: left;padding: 8px;'> " +
                        tab.fields.rekorder.beschreibung +
                        " - " +
                        tab.fields.rekorder.kategorie +
                        "</td><td style='border: 1px solid #dddddd;text-align: left;padding: 8px;'>" +
                        tab.fields.messgroesse.map((x) => x.beschreibung + " (" + x.feldname + ")").join(", ") +
                        "</td><td style='border: 1px solid #dddddd;text-align: left;padding: 8px;'> " +
                        (isUTC
                          ? toUTCDateString(new Date(tab.fields.startDatum))
                          : new Date(tab.fields.startDatum).toLocaleString()) +
                        "</td><td style='border: 1px solid #dddddd;text-align: left;padding: 8px;'> " +
                        (isUTC
                          ? toUTCDateString(new Date(tab.fields.endDatum))
                          : new Date(tab.fields.endDatum).toLocaleString()) +
                        "</td></tr></table>"
                    );
                    /* eslint-enable no-unsanitized/method */
                  });
              });
              //eslint-disable-next-line scanjs-rules/call_setTimeout
              setTimeout(function () {
                w?.print();
              }, 1);
              return false;
            }}
            disabled={
              tabData.fields.messgroesse.length === 0 ||
              tabData.fields.messgroesse.length > 6 ||
              tabData.graphLoading ||
              tabData.graphData.series.length === 0
            }
          >
            <Tooltip title="Drucken">
              <PrintIcon
                color={
                  tabData.fields.messgroesse.length === 0 ||
                  tabData.fields.messgroesse.length > 6 ||
                  tabData.graphLoading ||
                  tabData.graphData.series.length === 0
                    ? "disabled"
                    : "secondary"
                }
              />
            </Tooltip>
          </Button>
          <Button
            onClick={() => duplicateTab(tabData)}
            disabled={tabs.length > 6 || tabs.find((x) => x.index == selectedTab)?.fields.messgroesse.length === 0}
          >
            <Tooltip title="Tab duplizieren">
              <QueueIcon
                color={
                  tabs.length > 6 || tabs.find((x) => x.index == selectedTab)?.fields.messgroesse.length === 0
                    ? "disabled"
                    : "secondary"
                }
              />
            </Tooltip>
          </Button>
          <Button
            onClick={() => setOpenSaveDialog(true)}
            disabled={tabs.find((x) => x.index == selectedTab)?.fields.messgroesse.length === 0}
          >
            <Tooltip title="Eingabe Speichern">
              <SaveIcon
                color={tabs.find((x) => x.index == selectedTab)?.fields.messgroesse.length === 0 ? "disabled" : "secondary"}
              />
            </Tooltip>
          </Button>
          <Dialog open={openSaveDialog} onClose={() => setOpenSaveDialog(false)}>
            <DialogTitle>Suche speichern</DialogTitle>
            <DialogContent>
              <DialogContentText>Bitte geben Sie einen Namen für die Suche ein.</DialogContentText>
              <TextField
                variant="outlined"
                id="name"
                label="Name"
                value={savedSearchName}
                onChange={(ev) => setSavedSearchName(ev.target.value)}
                style={{ marginTop: "15px" }}
              />
            </DialogContent>
            <DialogActions>
              <Button
                color="secondary"
                variant="contained"
                onClick={() => setOpenSaveDialog(false)}
                className={classes.cancleDeleteButton}
              >
                Abbrechen
              </Button>
              <Button
                color="secondary"
                variant="contained"
                disabled={!savedSearchName}
                onClick={() => save()}
                style={{ minHeight: "36px", minWidth: "120px" }}
              >
                {sucheLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Speichern"}
              </Button>
            </DialogActions>
          </Dialog>
          <IconButton onClick={() => setFilter(!filter)}>
            {filter ? (
              <Tooltip title="Filter zuklappen">
                <ArrowForward />
              </Tooltip>
            ) : (
              <Tooltip title="Filter aufklappen">
                <FilterList />
              </Tooltip>
            )}
          </IconButton>
        </Grid>
        <Grid container spacing={2}>
          <Grid container style={{ marginLeft: "10px", marginBottom: "20px" }}>
            <Grid item xs={filter ? 8 : 12}>
              <NetzwirtschaftGraphen
                tabs={multiView == multiViewType.single ? [tabData] : tabs}
                layout={multiView == multiViewType.twoCols ? "double" : "single"}
              />{" "}
            </Grid>
            {filter ? (
              <React.Fragment>
                <Grid item xs={4}>
                  <Grid item container xs={12}>
                    <Grid container xs={1} style={{ paddingRight: "24px", justifyContent: "end" }}>
                      <Divider orientation="vertical" flexItem />
                    </Grid>
                    <Grid item xs={11}>
                      <Tabs
                        value={selectedTabFilter}
                        onChange={(event, value) => setSelectedTabFilter(value)}
                        indicatorColor="secondary"
                        textColor="secondary"
                        TabIndicatorProps={{
                          style: {
                            height: "5px",
                          },
                        }}
                      >
                        <Tab label="Allgemein" value="allgemein" />
                        <Tab label="Ansicht" value="ansicht" />
                      </Tabs>
                      {selectedTabFilter == "allgemein" ? (
                        <Grid container xs={12} md={12}>
                          <Grid item xs={12}>
                            <NetzwirtschaftInput tabData={tabData} />
                          </Grid>
                        </Grid>
                      ) : (
                        ""
                      )}
                      {selectedTabFilter == "ansicht" ? (
                        <div>
                          <Grid item xs={12} md={6}>
                            <Grid container>
                              <Grid item xs={12} md={12} style={{ display: "grid" }}>
                                <Grid item xs={12} md={12} style={{ display: "grid" }}>
                                  &nbsp;
                                </Grid>
                                <Grid item xs={12} md={12} style={{ display: "grid", textAlign: "left" }}>
                                  <Typography color="primary">Ansicht auswählen*</Typography>
                                </Grid>
                                <Grid item xs={12} md={12} style={{ display: "grid" }}>
                                  &nbsp;
                                </Grid>
                                <RadioGroup defaultValue={viewMode}>
                                  <FormControlLabel
                                    value="einzelansicht"
                                    control={<Radio size="small" />}
                                    onClick={() => {
                                      dispatch(setMultiView(multiViewType.single));
                                      dispatch(setViewMode("einzelansicht"));
                                    }}
                                    label={
                                      <React.Fragment>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                          <CheckBoxOutlineBlank style={{ marginLeft: "8px", marginRight: "8px" }} />
                                          Einzelansicht
                                        </div>
                                      </React.Fragment>
                                    }
                                  />
                                  <FormControlLabel
                                    value="multiansicht"
                                    control={<Radio size="small" />}
                                    onClick={() => {
                                      dispatch(setMultiView(multiViewType.multipleRows));
                                      dispatch(setViewMode("multiansicht"));
                                    }}
                                    label={
                                      <React.Fragment>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                          <ViewAgendaOutlined style={{ marginLeft: "8px", marginRight: "8px" }} />
                                          Multiansicht
                                        </div>
                                      </React.Fragment>
                                    }
                                  />
                                  <FormControlLabel
                                    value="2x2multiansicht"
                                    control={<Radio size="small" />}
                                    onClick={() => {
                                      dispatch(setMultiView(multiViewType.twoCols));
                                      dispatch(setViewMode("2x2multiansicht"));
                                    }}
                                    label={
                                      <React.Fragment>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                          <BorderAll style={{ marginLeft: "8px", marginRight: "8px" }} />
                                          2x2 Multiansicht
                                        </div>
                                      </React.Fragment>
                                    }
                                  />
                                </RadioGroup>
                                <Grid item xs={12} md={12} style={{ display: "grid" }}>
                                  &nbsp;
                                </Grid>
                                <Grid item xs={12} md={12} style={{ display: "grid" }}>
                                  &nbsp;
                                </Grid>
                                <Grid item xs={12} md={12}>
                                  <FormGroup row>
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          checked={tabData.graphData.showEreignisse}
                                          onChange={() => dispatch(setShowEreignisse(tabData.index))}
                                          name="showEreignisseSwitch"
                                        />
                                      }
                                      label="Ereignisse anzeigen"
                                    />
                                  </FormGroup>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </div>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </Grid>
                  <Grid container xs={12} md={12}>
                    <Grid container xs={1} style={{ paddingRight: "24px", justifyContent: "end" }}>
                      <Divider orientation="vertical" flexItem />
                    </Grid>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={9} style={{ marginLeft: "-24px", paddingRight: "20px" }}>
                      <Grid container item spacing={2}>
                        <Grid item xs={12} style={{ display: "grid" }}></Grid>
                        <Grid item md={6} style={{ display: "grid" }}>
                          <Button
                            variant="contained"
                            onClick={() => {
                              dispatch(getGraphData(tabData));
                            }}
                            color="secondary"
                            className={showGraphButton}
                            disabled={
                              tabData.fields.messgroesse.length === 0 ||
                              tabData.fields.messgroesse.length > 6 ||
                              tabData.graphLoading
                            }
                          >
                            Graph zeigen
                          </Button>
                        </Grid>
                        <Grid item md={6} style={{ display: "grid" }}>
                          <Button
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            onClick={() => dispatch(getExcelData(tabData))}
                            variant="contained"
                            className={showGraphButton}
                            color="secondary"
                            disabled={tabData.fields.messgroesse.length === 0 || tabData.exportLoading}
                          >
                            {tabData.exportLoading ? <CircularProgress size={25} /> : <React.Fragment>Export</React.Fragment>}
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  {showMap ? (
                    <Dialog open={true} maxWidth={false}>
                      <DialogTitle>{getMapDialogTitle(tabData.fields.uw, tabData.fields.messpunkt)}</DialogTitle>
                      <DialogContent>
                        <NetzwirtschaftMap mapBounds={tabData.mapBounds} messpunkt={tabData.fields.messpunkt} />
                      </DialogContent>
                      <DialogActions>
                        <Button
                          color="secondary"
                          variant="contained"
                          onClick={() => setShowMap(false)}
                          style={{ marginRight: "12px", marginBottom: "12px" }}
                        >
                          Schliessen
                        </Button>
                      </DialogActions>
                    </Dialog>
                  ) : (
                    ""
                  )}
                </Grid>
              </React.Fragment>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      </Paper>
    </TabPanel>
  );
};
